<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <form id="UpdateProfile" @submit.prevent="UpdateProfile" >
        <CCardHeader>
            <CCol col="6" style="font-size: 25px;">تعديل بيانات الموقع</CCol>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol sm="6">
              <CInput label="رقم الهاتف"
                id="mobile"
                v-model="profile.mobile"
                pattern="^[0-9]*$"
                class="required"
                placeholder=" أدخل رقم هاتف لعرضه في الموقع"
                :invalidFeedback="errors.mobile"
                required
              />
            </CCol>
            <CCol sm="6">
              <CInput label="البريد الإلكتروني"
                id="email"
                type="email"
                v-model="profile.email"
                pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                class="required"
                placeholder=" أدخل بريد إلكتروني لعرضه في الموقع"
                :invalidFeedback="errors.email"
                required
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <CInput label="Address"
                id="address"
                v-model="profile.address"
                class="required"
                placeholder="أدخل العنوان بالانجليزية"
                :invalidFeedback="errors.address"
                required
              />
            </CCol>
            <CCol sm="6">
              <CInput label="العنوان"
                id="address_ar"
                v-model="profile.address_ar"
                class="required"
                placeholder="أدخل العنوان بالعربي"
                :invalidFeedback="errors.address_ar"
                required
              />
            </CCol>
          </CRow>
          <CRow>
              <CCol sm="2">
                <label>نبذة بالانجليزية </label>
              </CCol>
              <CCol sm="10">
                <client-only>
                  <VueEditor v-model='profile.about' />
                </client-only>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="2">
                <label>نبذة بالعربي </label>
              </CCol>
              <CCol sm="10">
                <client-only>
                  <VueEditor v-model='profile.about_ar' />
                </client-only>
              </CCol>
            </CRow>
            </CCardBody>
            <CCardFooter>
            <CButton type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="button" size="sm" color="warning" @click="goBack"><CIcon name="cil-ban"/> رجوع </CButton>
          </CCardFooter>
          </form>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  name: 'UpdateProfile',
  components: {
    VueEditor
  },
  data () {
    return {
      profile: [],
      errors: []
    }
  },
  created () {
    this.$http
      .get(`${this.$hostUrl}site-profile`)
      .then((response) => {
        this.profile = response.data.data
      })
  },
  methods: {
    async UpdateProfile () {
      const formData = new FormData()
      formData.append('mobile', this.profile.mobile)
      formData.append('email', this.profile.email)
      formData.append('address', this.profile.address)
      formData.append('address_ar', this.profile.address_ar)
      formData.append('about', this.profile.about)
      formData.append('about_ar', this.profile.about_ar)
      formData.append('_method', 'Post')
      this.errors = await this.postRequest(formData, `${this.$hostUrl}site-profile/update`, '/site-profile')
    },
    goBack () {
      this.profileOpened ? this.$router.go(-1) : this.$router.push({ path: '/site-profile' })
    }
  }
}
</script>
